import ApiProvider from '../services/ApiProvider'
// import { Source } from '../models/Source'

export default class WindowManager {
  /**
   * WindowManager component
   * @param {VueComponent} vue
   * @param {String} modal
   * @param {BookingUrlParams} urlOptions
   */
  constructor (vue, modal, urlOptions) {
    this.vue = vue
    this.modal = modal

    this.urlOptions = urlOptions
    this.registerListeners()
  }

  /**
   * Returns the height of the widget
   * @return {Number}
   */
  getWidgetHeight () {
    const inner = this.vue.$el.children['dmn-widget-inner']
    return inner.clientHeight
  }

  /**
   * Registers the event listeners to their respective methods
   * @return {Void}
   */
  registerListeners () {
    this.vue.$on('stage.opening', (e) => this.handleOpeningStage(e))
    this.vue.$on('stage.resize', (e) => this.handleOpeningStage(e))
    this.vue.$on('stage.opened', (e) => this.handleOpenedStage(e))
  }

  /**
   * This is all thanks to IE not supporting the .dataset property.
   * Basically just grabs the data attribute using the dataset property,
   * but if we're in IE, grab the attribute
   * @param {Object} elm
   * @param {String} dataset
   * @return {String}
   */
  getDataset (elm, dataset) {
    if (elm.dataset === void 0 || elm.dataset === null) {
      return elm.getAttribute('data-' + dataset)
    } else {
      return elm.dataset[dataset]
    }
  }

  /**
   * Sets how far from the top a dropdown should be positioned
   * @param {Number} stage
   * @return {Number}
   */
  setDropdownYOffset (stage) {
    const elm = this.vue.$el
    const dropdowns = elm.querySelectorAll('.stage .dropdown')
    let height = 0

    let dropdown
    let id
    // Go through every dropdown that's visible, grab the heights
    // and set our new one to have an offset of the sum of these heights.
    for (let i = 0; i < dropdowns.length; i++) {
      id = parseInt(this.getDataset(dropdowns[i].parentElement, 'stage'))
      dropdown = this.vue.stageManager.getStageById(id)

      if (dropdown.index < stage.index && dropdown.visible) {
        height += (dropdowns[i].clientHeight + 1)
      }
    }

    const stageElm = this.getStageElement(stage)
    // But if it's full screen, we want to make it have maximum zindex
    const zIndex = stage.fullScreen ? 9999 : height

    stageElm.style.marginTop = height + 'px'
    stageElm.style.zIndex = zIndex

    return height
  }

  /**
   * Gets the element for the specified stage
   * @param {*} stage
   * @return {Element}
   */
  getStageElement (stage) {
    return this.vue.$el.querySelector('.stage[data-stage="' + stage.id + '"]')
  }

  /**
   * Sets how high each scrollable box should be
   * @param {Object} stage
   * @return {Promise}
   */
  setOverflowHeight (stage) {
    const stageElm = this.getStageElement(stage)
    const scrollHeights = stageElm.querySelectorAll('.scroll-height')
    let offset = 0
    // Content hasn't updated yet, so we need to wait for the next tick.
    return new Promise((resolve, reject) => {
      this.vue.$nextTick(() => {
        const widgetHeight = this.getWidgetHeight()
        for (let i = 0; i < scrollHeights.length; i++) {
          // Add up the offsetParents
          offset = scrollHeights[i].offsetTop
          offset = this.recurseOffset(scrollHeights[i], offset)
          scrollHeights[i].style.height = widgetHeight - offset + 'px'
        }
        resolve()
      })
    })
  }

  /**
   * Goes through the parents of an element and calculates the total Y offset
   * so we can calculate how high it actually is.
   * @param {Object} elm
   * @param {Number} offset
   * @return {Number}
   */
  recurseOffset (elm, offset) {
    if (elm.offsetParent && elm.offsetParent !== this.vue.$el) {
      offset += elm.offsetParent.offsetTop
      this.recurseOffset(elm.offsetParent, offset)
    }
    return offset
  }

  /**
   * When a stage is opened, this sets the scroll height and the Y offset
   * @param {*} stageIndex
   * @return {Void}
   */
  handleOpeningStage (stageIndex) {
    const stage = this.vue.stageManager.getStageById(stageIndex)

    if (!stage) return false

    const offset = this.setDropdownYOffset(stage)
    this.setOverflowHeight(stage, offset)
  }

  /**
   * Automatically scrolls to the selected list slot component when a new
   * scrollable list is rendered
   * @return {Void}
   */
  scrollToSelection () {
    const children = this.vue.$children
    for (let i = 0; i < children.length; i++) {
      if (children[i].$options.name === 'listSlot' && children[i].selected) {
        let offset = children[i].$el.offsetTop
        let parent = children[i].$el.offsetParent

        parent.scrollTop = offset
      }
    }
  }

  /**
   * Checks if the referenced element is scrolled to near the bottom. Uses a
   * tolerance of 50px
   * @param {Object} elm
   * @return {Boolean}
   */
  isScrolledToBottom (elm) {
    const tolerance = 50
    elm = elm.target
    return elm.scrollHeight - elm.scrollTop <= (elm.clientHeight + tolerance)
  }

  goToCheckout (booking, additionalTypes) {
    this.openCheckoutLink(booking, additionalTypes)
  }

  openCheckoutLink (booking, additionalTypes) {
    let bookingUrl = ApiProvider.getBookingUrl()

    if (!bookingUrl) {
      return
    }

    const body = window.document.getElementsByTagName('body')
    const form = window.document.createElement('form')
    form.setAttribute('action', bookingUrl)
    form.setAttribute('method', 'GET')

    const checkoutParams = ApiProvider.createQueryParams(
      booking,
      this.urlOptions,
      additionalTypes
    )

    Object.keys(checkoutParams).forEach((key) => {
      const value = checkoutParams[key]
      if (value) {
        const input = window.document.createElement('input')
        input.setAttribute('type', 'hidden')
        input.setAttribute('name', key)
        input.setAttribute('value', value)

        form.appendChild(input)
      }
    })

    body[0].appendChild(form)
    form.submit()
  }
}



// WEBPACK FOOTER //
// ./src/managers/WindowManager.js